
const USER_SETTINGS = {
  APP_OPTIONS: {
    ATTRIBUTE: "appOptions",
    PUSH_ENABLED: "appOptions.pushEnabled"
  },
  EXTENSION_OPTIONS: {
    ATTRIBUTE: "extensionOptions",
    PUSH_ENABLED: "extensionOptions.pushEnabled"
  }
}

const ONBOARDING_STATE = {
  ONBOARDING_PREFIX: "onboarding",
  INITIAL_STATE: "onboarding-01",
  ACTIVATED_STATE: "new user",
}

const ROLES = {
  ADMIN : "admin",
  USER : "user",
}

export {
  USER_SETTINGS,
  ONBOARDING_STATE,
  ROLES
};